const translation = {
  title: '容器实例',
  create: {
    title: '创建容器实例',
  },
  overview: {
    home: '首页',
    workload: '工作负载',
    storage: '存储资源',
    other: '其它资源',
    containerInstance: '容器实例',
    trainTask: '训练任务',
    inferenceService: '推理服务',
    model: '模型',
    dataset: '数据集',
    image: '容器镜像',
    disk: '存储磁盘',
    repository: '镜像仓库',
    userCenter: '个人中心',
    welcome: '欢迎您使用{{name}}',
  },
  userPage: {
    welcomeTitle: 'Hi，欢迎来到 {{name}} 机器学习平台',
    description:
      '机器学习平台是一套服务于专业算法工程师，整合云原生的工具+算力 (GPU、CPU云服务器)，进行一站式AI算法开发和迭代的平台。',
    containerInstanceList: '容器实例列表',
    trainingTaskList: '训练任务列表',
    inferenceServiceList: '推理服务列表',
    moreData: '更多数据',
  },
  form: {
    name: '实例名称',
    nameTooltip: '容器实例的唯一标识名称，支持中英文、数字和短横线',
    resourceSelector: '资源选择',
    volumeMounts: '挂载存储',
    image: '设置镜像',
    workingDir: '工作目录',
    workingDirTooltip: '容器启动时的工作目录路径，启动命令将在此目录下执行',
    cmd: '启动命令',
    cmdTooltip:
      '系统环境变量，通过"{{变量名称}}"方式进行引用。username: 当前用户，password: 随机密码，resource_id: 容器实例资源ID',
    args: '启动参数',
    argsTooltip: '自定义启动参数，可以在启动变量中进行引用',
    env: '环境变量',
    ports: '端口映射',
    confirm: '确定',
    cancel: '取消',
    permission: '权限',
  },
  detail: {
    title: '容器实例详情',
    tabs: {
      detail: '详情',
      log: '日志',
      event: '事件',
      monitor: '监控',
    },
    loginContainer: '登录容器',
  },
  edit: {
    title: '编辑容器实例',
  },
  volumeMountsEditor: {
    readWrite: '读写',
    readOnly: '只读',
    mountPathPlaceholder: '挂载路径',
    modePlaceholder: '读写模式',
  },
  resources: {
    containerInstance: '容器实例',
    trainingTask: '训练任务',
    inferenceService: '推理服务',
    dataset: '数据集',
    model: '模型',
    containerImage: '容器镜像',
    storageResource: '存储资源',
    imageRepository: '镜像仓库',
    createContainerInstance: '创建实例',
    createTrainingTask: '创建任务',
    createInferenceService: '创建服务',
    createDataset: '创建数据集',
    createModel: '创建模型',
    createContainerImage: '创建镜像',
    total: '总数',
    running: '运行中',
    private: '个人私有',
    diskCount: '存储磁盘数',
    privateDiskCount: '个人私有磁盘数',
  },
  billing: {
    assetAccount: '资产账户',
    rechargeRemittance: '充值汇款',
    invoice: '开票',
    availableBalance: '可用额度：',
    loading: '加载中...',
    loadingFailed: '加载失败',
    incomeExpenseOverview: '收支概览',
    monthlyIncome: '本月收入',
    monthlyOrderExpenses: '本月订单支出',
    myBenefits: '我的权益',
    activeCoupons: '生效中代金券数',
    totalCoupons: '代金券总数',
    productInformation: '产品信息',
    viewMore: '查看更多',
    informationNotifications: '信息通知',
  },
  currency: {
    CNY: '元',
    USD: '美元',
  },
  modelManage: {
    title: '模型服务',
    addModel: '新建模型',
    createTitle: '创建模型',
    editTitle: '编辑模型',
    detailTitle: '模型详情',
    searchPlaceholder: '请输入模型名称或ID进行搜索',
    filter: {
      status: '状态',
      scenario: '任务场景',
      provider: '模型提供方',
    },
    table: {
      id: '名称 / ID',
      status: '状态',
      description: '模型描述',
      taskScenario: '任务场景',
      modelSize: '模型大小',
      contextLength: '上下文长度',
      maxGenerationLength: '最大生成长度',
      modelProvider: '模型提供方',
      sortOrder: '排序序号',
      createdAt: '创建时间',
      creator: '创建者',
      action: '操作',
      detail: '详情',
      edit: '编辑',
      offline: '下线',
      online: '发布',
      delete: '删除',
      onlineStatus: '已发布',
      offlineStatus: '未发布',
    },
    form: {
      name: '模型名称',
      nameTooltip: '模型的唯一标识名称',
      nameRequired: '请输入模型名称',
      nameMinLength: '模型名称至少3个字符',
      nameMaxLength: '名称不超过100个字符',
      namePlaceholder: '请输入模型名称',
      relatedService: '关联服务',
      relatedServiceRequired: '请选择关联服务',
      description: '模型描述',
      descriptionTooltip: '模型的详细描述信息',
      descriptionMaxLength: '描述不超过500个字符',
      descriptionPlaceholder:
        '请输入一句运营为模型描述，该简介将在模型广场的卡片中展示',
      taskScenario: '任务场景',
      taskScenarioTooltip: '模型适用的任务场景',
      taskScenarioRequired: '请选择任务场景',
      taskScenarioPlaceholder: '请选择任务场景',
      modelSize: '模型大小',
      modelSizeTooltip: '模型的参数规模',
      modelSizeRequired: '请输入模型大小',
      modelSizePlaceholder: '示例：7b、63b',
      modelSizeOption: '模型大小选项',
      modelSizeOptionRequired: '请选择模型大小选项',
      contextLength: '上下文长度',
      contextLengthTooltip: '模型支持的最大上下文token数',
      contextLengthRequired: '请输入上下文长度',
      contextLengthPlaceholder: '示例：64k, 128k, 256k',
      contextLengthOption: '上下文长度选项',
      contextLengthOptionRequired: '请选择上下文长度选项',
      maxGenerateLength: '最大生成长度',
      maxGenerateLengthTooltip: '模型单次生成的最大token数',
      maxGenerateLengthRequired: '请输入最大生成长度',
      maxGenerateLengthPlaceholder: '示例：64k, 128k, 256k',
      maxGenerationLength: '最大生成长度',
      maxGenerationLengthTooltip: '模型单次生成的最大token数',
      maxGenerationLengthRequired: '请输入最大生成长度',
      maxGenerationLengthPlaceholder: '例如：2048, 4096',
      modelProvider: '模型提供方',
      modelProviderTooltip: '模型的提供商或开发组织',
      modelProviderRequired: '请选择模型提供方',
      modelProviderPlaceholder: '请选择模型提供方',
      modelDetails: '模型详情',
      modelDetailsTooltip:
        '请详细描述模型的特点、优势、适用场景等信息，支持富文本格式',
      modelDetailsRequired: '请填写模型详情',
      sortOrder: '排序序号',
      sortOrderRequired: '请输入排序序号',
      sortOrderPlaceholder: '示例：1, 2, 3',
      customTags: '自定义标签',
      addCustomTag: '添加自定义标签',
      tagNamePlaceholder: '请输入标签名称',
      addCustomTagButton: '+ 自定义标签',
      creator: '创建者',
      creatorTooltip: '模型的创建者信息',
      creatorPlaceholder: '请输入创建者',
      confirm: '确定',
      cancel: '取消',
    },
    taskScenarios: {
      textGeneration: '文本生成',
      chatbot: '对话聊天',
      codeGeneration: '代码生成',
      translation: '翻译',
      summarization: '摘要生成',
      questionAnswering: '问答',
      imageGeneration: '图像生成',
      other: '其他',
    },
    providers: {
      custom: '自定义',
    },
    action: {
      create: '创建模型',
      edit: '编辑模型',
    },
    modal: {
      delete: {
        title: '确认删除',
        content: '请确认是否删除该模型。',
        confirm: '确认',
        cancel: '取消',
      },
      offline: {
        title: '下线模型',
        content: '请确认是否将该模型从模型广场下线。',
      },
      online: {
        title: '发布模型',
        content: '请确认是否将该模型发布到模型广场。',
      },
    },
    message: {
      fetchFailed: '获取模型列表失败，请重试',
      fetchCatalogFailed: '获取关联服务失败',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败，请重试',
      offlineSuccess: '下线成功',
      onlineSuccess: '发布成功',
      publishSuccess: '发布成功',
      publishFailed: '发布失败，请重试',
      operationFailed: '操作失败，请重试',
      createSuccess: '创建成功',
      createFailed: '创建失败，请重试',
      updateSuccess: '更新成功',
      updateFailed: '更新失败，请重试',
      fetchDetailFailed: '获取模型详情失败',
      imageSizeExceeded: '图片大小不能超过 500KB，当前大小：{{size}}KB',
      addTagSuccess: '添加标签成功',
      addTagFailed: '添加标签失败',
      detailsRequired: '模型详情不能为空',
      uploadImage: '上传图片',
      fileTypeError: '不支持的文件类型',
      fileSizeExceeded: '文件大小不能超过 {{size}}MB',
      uploadFailed: '上传失败，请重试',
      uploadImageFailed: '图片上传失败',
    },
  },
  statistics: {
    title: '用量统计',
    filters: {
      userAccount: '用户账号',
      apiKey: 'API Key',
      model: '调用模型',
      statisticsPeriod: '统计周期',
      allApiKeys: '全部API Key',
      allModels: '全部调用模型',
      selectUserAccount: '请选择用户账号',
      selectApiKey: '请选择API Key',
      selectModel: '请选择调用模型',
      periodTooltip:
        '此处将按照执行完成时间进行周期筛选。由于数据量较大，查询超过30天的用量数据可能需要5-10秒等待时间。',
    },
    actions: {
      reset: '重置',
      query: '查询',
    },
    summary: {
      modelUsedCount: '调用模型总数',
      callCount: '调用服务总次数',
      totalTokens: '调用token总数',
      inputTokens: '输入token总数',
      outputTokens: '输出token总数',
    },
    messages: {
      fetchFailed: '获取统计数据失败，请重试',
      loadApiKeysFailed: '加载API Key列表失败',
      loadModelsFailed: '加载模型列表失败',
      cappedToThreeMonths: '查询时间范围已限制为最近3个月的数据。',
      apiOnlyNote: '当前仅统计通过API调用产生的用量数据。',
    },
    charts: {
      trendTitle: '模型用量趋势图',
      distributionTitle: '用量分布图',
      noData: '暂无数据',
      userDistribution: '用户调用分布',
      apiKeyDistribution: 'API Key调用分布',
      modelDistribution: '模型服务调用分布',
      total: '总计',
    },
    metrics: {
      requestCount: '请求量',
      totalTokens: 'Token总数',
      inputTokens: '输入Token数',
      outputTokens: '输出Token数',
    },
  },
  bills: {
    title: '交易账单',
  },
  gpuDashboard: {
    title: 'GPU资源列表',
    table: {
      zone: '可用区',
      cluster: '集群',
      ip: 'IP地址',
      hostname: '主机名',
      resourceGroup: '资源组',
      gpuType: 'GPU类型',
      gpuTotal: 'GPU总数',
      gpuOccupied: 'GPU占用数',
      gpuAvailable: 'GPU可用数',
      cpuResource: 'CPU资源',
      memoryResource: '内存资源',
      cpuCore: '核',
    },
    filter: {
      zone: '可用区',
      zonePlaceholder: '请选择可用区',
      cluster: '集群',
      clusterPlaceholder: '请选择集群',
      query: '查询',
      reset: '重置',
      export: '导出数据',
    },
    statistic: {
      total: '总数',
      occupied: '占用',
      available: '可用',
    },
    message: {
      loadStatsFailed: '加载统计信息失败，请稍后重试',
    },
    pagination: {
      total: '共 {{total}} 条',
      itemsPerPage: '条/页',
      jumpTo: '跳至',
      jumpToConfirm: '确定',
      page: '页',
      prevPage: '上一页',
      nextPage: '下一页',
    },
  },
  storageQuota: {
    title: '资源配额',
    detail: '资源配额详情',
    edit: '编辑配额详情',
    create: '资源配额',
  },
  fileStorage: {
    title: '文件存储',
  },
  inspection: {
    title: '系统巡检',
  },
}

export default translation
